import { styled } from 'styled-components'
import Box from '@mui/material/Box'
import { List, ListItemText } from '@mui/material'

export const StyledTermsOfServiceWrapper = styled(Box)`
 height: 100vh;
 background: white;
 padding: 24px 48px 24px 48px;
 overflow-y: auto;
`

export const StyledHorizontalSpacer = styled(Box)`
 width: 100%;
 height: 1px;
 background-color: lightgray;
 margin: 8px 0px 8px 0px;
`

export const StyledText = styled(Box)`
 padding: 8px 0px 8px 0px;
`

export const StyledList = styled(List)`
 padding: 0px 24px 0px 24px !important;
`

export const StyledListItem = styled(ListItemText)`
 padding-bottom: 4px;
`

export const StyledHeader = styled(Box)`
 text-align: center;
 font-size: 24px;
 font-weight: bold;
`
